import React from 'react';
import { Container, Row, Col, Accordion } from 'react-bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './AboutUs.css';

// Uvoz slika
import aboutUsImg1 from '../../assets/AboutUsPhotos/aboutUsImg1.jpg';
import aboutUsImg2 from '../../assets/AboutUsPhotos/aboutUsImg2.jpg';
import aboutUsImg3 from '../../assets/AboutUsPhotos/aboutUsImg3.jpg';

const AboutUs = () => {
  return (
    <div className="about-page">
      
      {/* --- Section 1 ------------------------------------------------------- */}
      <section className="about-section-1 py-5">
        <Container>
          <Row className="align-items-center">
            {/* Text left */}
            <Col lg={6} className="text-start pe-lg-5 order-2 order-lg-1">
              <h6 className="about-subtitle">LEARN ABOUT US</h6>
              <h2 className="about-main-title mb-4">OUR STORY</h2>
              <div className="about-description">
                <p>
                  Since 2019 Happy Dream has provided safe, sound, and well-maintained 
                  homes to our tenants while providing them a high level of service 
                  and professionalism.
                </p>
                <p>
                  We leverage technology and local service personnel to serve our 
                  tenants around the clock. We pride ourselves on delivering same-day 
                  responses to tenant questions, concerns, and, most importantly, 
                  service requests.
                </p>
                <p>
                  Our mission is for our tenants to call their Happy Dream Property 
                  “Home Sweet Home” for years to come.
                </p>
              </div>
            </Col>

            {/* Img. right */}
            <Col lg={6} className="mb-5 mb-lg-0 order-1 order-lg-2">
              <div className="about-img-wrapper right-shadow">
                <img src={aboutUsImg1} alt="Our Story" className="img-fluid about-img" />
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* --- Section 2 ------------------------------------------------------- */}
      <section className="about-section-2 py-5 bg-light-gray">
        <Container>
          <Row className="align-items-center">
            {/* Img. left */}
            <Col lg={6} className="mb-5 mb-lg-0">
              <div className="about-img-wrapper left-shadow">
                <img src={aboutUsImg2} alt="Our Commitment" className="img-fluid about-img" />
              </div>
            </Col>

            {/* Text right */}
            <Col lg={6} className="text-start ps-lg-5">
              <h6 className="about-subtitle">HAPPY DREAM</h6>
              <h2 className="about-main-title mb-4">OUR COMMITMENT</h2>
              <div className="about-description">
                <p>
                  All of us at Happy Dream want you to know that you’re not just a 
                  resident to us, you are our neighbor. We take care of our neighbors here!
                </p>
                <p>
                  Happy Dream’s staff strive to work as one team to provide you with 
                  quality housing and customer service. We want you to enjoy your 
                  apartment home and the lifestyle provided in this community.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* --- Section 3 ------------------------------------------------------- */}

      <section className="why-choose-section">
        <Container>
          <Row className="align-items-center py-5">
            
            {/* Left side: Headline*/}
            <Col lg={4} className="text-start mb-4 mb-lg-0">
              <h2 className="why-title">
                WHY CHOOSE <br />
                <span className="highlight-blue">HAPPY DREAM?</span>
              </h2>
            </Col>

            {/* Right side with three symbols */}
            <Col lg={8}>
              <Row className="text-center">
                {/* Symbol 1 */}
                <Col md={4} className="mb-4 mb-md-0">
                  <div className="why-icon-box">
                    <i className="bi bi-telephone icon-style"></i> {/* Ili <img src={icon1} /> */}
                    <p className="why-icon-text">Top level <br /> Customer Service</p>
                  </div>
                </Col>

                {/* Symbol 2 */}
                <Col md={4} className="mb-4 mb-md-0">
                  <div className="why-icon-box">
                    <i className="bi bi-house-door icon-style"></i>
                    <p className="why-icon-text">Prepare the <br /> properties for rent</p>
                  </div>
                </Col>

                {/* Symbol 3 */}
                <Col md={4}>
                  <div className="why-icon-box">
                    <i className="bi bi-person-check icon-style"></i>
                    <p className="why-icon-text">Performance-Driven</p>
                  </div>
                </Col>
              </Row>
            </Col>

          </Row>
        </Container>
      </section>

      {/* --- Section 4 ------------------------------------------------------- */}
      <section className="faq-section py-5 bg-white">
        <Container className="py-5">
          <Row>
            {/* LEVA STRANA: NASLOV I SLIKA */}
            <Col lg={5} className="text-start mb-5 mb-lg-0">
              <h2 className="faq-main-title mb-4">FREQUENTLY ASKED <br /> QUESTIONS</h2>
              <div className="faq-img-wrapper">
                <img src={aboutUsImg3} alt="FAQ" className="img-fluid about-img" />
                <div className="faq-shadow-bg"></div>
              </div>
            </Col>

            {/* DESNA STRANA: ACCORDION */}
            <Col lg={7} className="ps-lg-5">
              <Accordion flush className="custom-faq-accordion">
                
                {/* PITANJE 1 */}
                <Accordion.Item eventKey="0" className="mb-4 border-bottom">
                  <Accordion.Header>
                    How can Happy Dream Services help protect my investments?
                  </Accordion.Header>
                  <Accordion.Body>
                    We place your interests first, from the way we structure our reporting 
                    to the way our 24-hour service center is organized to provide you 
                    with immediate problem-solving and big-picture data. We maximize your 
                    assets’ value through efficiency and genuine care for your goals.
                  </Accordion.Body>
                </Accordion.Item>

                {/* PITANJE 2 */}
                <Accordion.Item eventKey="1" className="border-bottom">
                  <Accordion.Header>
                    What is your tenant relationship philosophy?
                  </Accordion.Header>
                  <Accordion.Body>
                    We recognize that tenants are one of your building’s top assets. We 
                    empower our teams to create memorable tenant experiences that build 
                    your brand and benefit your bottom line. We’ll promote practices and 
                    programs that enhance the best relationships with tenants and increase 
                    business cooperation. By responding to building and tenant issues quickly 
                    and by maintaining brand reputation, we help maximize your investment.
                  </Accordion.Body>
                </Accordion.Item>

              </Accordion>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default AboutUs;